// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-module_list__mPrpw {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
}

.list-module_item__B4tRg {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    position: relative;
}

.list-module_itemDivided__cU1d9 {
    border-bottom-width: 1px;
    border-bottom-style: solid;
}

.list-module_itemButton__VaueY {
    appearance: none;
    background: transparent;
    border: none;
    outline: none;
    padding: 8px 16px 8px 16px;
    margin: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    text-align: left;
    -webkit-tap-highlight-color: transparent;
}

/* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */
@media (hover: hover) and (pointer: fine) {
    .list-module_itemButton__VaueY:hover:not(:disabled) {
        background-color: rgba(0, 0, 0, 0.04);
    }
}

.list-module_itemButton__VaueY:focus-visible {
    background-color: rgba(0, 0, 0, 0.08);
}

.list-module_itemButton__VaueY:active:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.08);
}

.list-module_itemButtonSelected__D7KfH {
    background-color: rgba(0, 0, 0, 0.08);
}

.list-module_itemButtonDisabled__EGUoI {
    cursor: not-allowed;
    opacity: 0.6;
}

.list-module_leading__DkcM2 {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.list-module_text__MHqA2 {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.list-module_textPrimary__DufoK {
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.list-module_textSecondary__Fzfav {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.list-module_trailing__PEwYS {
    flex-shrink: 0;
    margin-left: auto;
    padding-right: 24px;
    display: flex;
    align-items: center;
}

.list-module_trailingText__EGG2J {
    font-size: 14px;
    line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/list/list.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA,wGAAwG;AACxG;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n}\n\n.item {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.itemDivided {\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n}\n\n.itemButton {\n    appearance: none;\n    background: transparent;\n    border: none;\n    outline: none;\n    padding: 8px 16px 8px 16px;\n    margin: 0;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: inherit;\n    color: inherit;\n    text-align: left;\n    -webkit-tap-highlight-color: transparent;\n}\n\n/* Touch browsers emulate a sticky :hover after a tap/long press — apply hover only for real pointers. */\n@media (hover: hover) and (pointer: fine) {\n    .itemButton:hover:not(:disabled) {\n        background-color: rgba(0, 0, 0, 0.04);\n    }\n}\n\n.itemButton:focus-visible {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.itemButton:active:not(:disabled) {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.itemButtonSelected {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.itemButtonDisabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.leading {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.text {\n    flex: 1 1 auto;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.textPrimary {\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.textSecondary {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.trailing {\n    flex-shrink: 0;\n    margin-left: auto;\n    padding-right: 24px;\n    display: flex;\n    align-items: center;\n}\n\n.trailingText {\n    font-size: 14px;\n    line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list-module_list__mPrpw`,
	"item": `list-module_item__B4tRg`,
	"itemDivided": `list-module_itemDivided__cU1d9`,
	"itemButton": `list-module_itemButton__VaueY`,
	"itemButtonSelected": `list-module_itemButtonSelected__D7KfH`,
	"itemButtonDisabled": `list-module_itemButtonDisabled__EGUoI`,
	"leading": `list-module_leading__DkcM2`,
	"text": `list-module_text__MHqA2`,
	"textPrimary": `list-module_textPrimary__DufoK`,
	"textSecondary": `list-module_textSecondary__Fzfav`,
	"trailing": `list-module_trailing__PEwYS`,
	"trailingText": `list-module_trailingText__EGG2J`
};
export default ___CSS_LOADER_EXPORT___;
